<template>
  <div>
    <div class="form-group">
      <label for="values.odprtDni">{{ $t('days') }}</label>
      <ValidationProvider name="odprto dni" vid="odprtDni" v-slot="{ errors }" rules="required">
        <input class="form-control" type="number" v-model="values.odprtDni" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <ValidationProvider name=število dodatnih ležišč vid="stDodatnihlezisc" v-slot="{ errors }" rules="required">
        <label for="values.stDodatnihlezisc">{{ $t('additionalBeds') }}</label>
        <input class="form-control" type="number" v-model="values.stDodatnihlezisc" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="values.stProdanihNE">{{ $t('unitsSold') }}</label>
      <ValidationProvider name="število prodanih namestivenih enot" vid="stProdanihNE" v-slot="{ errors }" rules="required">
        <input class="form-control" v-model="values.stProdanihNE" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <ValidationProvider name="last name" vid="name.last" v-slot="{ errors }" rules="required">
        <label for="values.statusPor">{{ $t('status') }}</label>
        <select class="form-control" v-model="values.status" :class="{ 'is-invalid': errors[0] }">
          <option value="11">ODPRT - turisti so prihajali</option>
          <option value="12">ODPRT - turistov ni bilo</option>
          <option value="50">ZAČASNO ZAPRT - drugi razlogi</option>
          <option value="51">ZAČASNO ZAPRT - adaptacija</option>
          <option value="54">ZAČASNO ZAPRT - sezonska zaprtost</option>
          <option value="61">61 - prenehanje oddajanja nastavitvenih kapacitet turistom</option>
          <option value="62">62 - ZAČASNO ZAPRT - nastanitvene kapacitete še v pripravi</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Values',
    props: ['values']
  }
</script>

<i18n>
{
  "en": {
    "days": "Open days",
    "additionalBeds": "Additional beds",
    "unitsSold": "Number of units sold",
    "status": "Report status"
  },
  "sl": {
    "days": "Odprto dni",
    "additionalBeds": "Število dodatnih ležišč",
    "unitsSold": "Število prodanih namestitvenih enot",
    "status": "Status poročila"
  }
}
</i18n>
